import { PSort } from '@/types/utils'

declare var moment: any
export interface IUtil {
  /**
   * 传参空值过滤
   * @param opt 待处理对象
   */
  optionSort(opt: PSort): object
  /**
   * 参数封装
   * @param opt 待处理参数
   */
  encParam(opt: any): object
  /**
   * 加密密码
   * @param str 密码
   */
  encodePwd(str: string): string
  /**
   * 判断权限
   * @param   {string}  role   用户权限
   * @param   {string}  roles  所有权限
   */
  hasAuth(role: string, roles: string): boolean
  /**
   * 创建唯一字符串
   */
  createUniqueString(): string
}
class Util implements IUtil {
  public optionSort(opt: PSort): object {
    let obj: PSort = {}
    if (typeof opt === 'object') {
      for (let k in opt) {
        if (opt[k] !== null && opt[k] !== '') {
          obj[k] = opt[k]
        }
      }
    } else {
      obj = opt
    }

    return obj
  }
  // 参数封装
  encParam(opt: any) {
    return { data: JSON.stringify(this.optionSort(opt)) }
  }
  public encodePwd(str: string): string {
    let out = ''
    for (let c of str) {
      out += c.charCodeAt(0) - 23
    }
    return out
  }
  public hasAuth(role: string, roles: string): boolean {
    const roleArr = role.split('|')
    return (
      roles.includes('0') || roles.includes(roleArr[0]) || roles.includes(role)
    )
  }
  public createUniqueString() {
    const timestamp = +new Date() + ''
    const randomNum = parseInt((1 + Math.random()) * 65536 + '') + ''
    return (+(randomNum + timestamp)).toString(32)
  }
  public copy(obj_a: any, obj_b: any) {
    for (let key in obj_a) {
      if (obj_b.hasOwnProperty(key)) {
        obj_a[key] = obj_b[key]
      }
    }
  }
  public toDate(t: Date | string) {
    return t && moment(t).format('YYYY-MM-DD HH:mm:ss') || t
  }
}
export default new Util()
